import React from 'react';
import { Building2, Sparkles, Briefcase, Newspaper, TrendingUp, Target } from 'lucide-react';

const FEATURES = [
  {
    icon: Sparkles,
    title: 'AI Overviews',
    description: 'Get concise, AI-generated summaries for stocks in your watchlist so you can quickly understand key drivers and context.',
  },
  {
    icon: Briefcase,
    title: 'Portfolio Tracking',
    description: 'Create and monitor your portfolio in one place and see how your positions perform over time.',
  },
  {
    icon: Newspaper,
    title: 'News with Context',
    description: 'Track material news for your holdings and watchlist, with AI sentiment and summaries so you can act on what matters.',
  },
  {
    icon: TrendingUp,
    title: 'Signals That Match Your Style',
    description: 'Use built-in buy/sell signals to find ideas that fit your criteria, or add your own rules and backtest them to check performance.',
  },
];

const About = () => (
  <div className="page-content info-page about-page">
    <header className="info-page-header">
      <h2>
        <Building2 size={22} className="info-page-header-icon" aria-hidden />
        About Bidsig
      </h2>
    </header>

    <div className="info-hero-card">
      <div className="info-hero-body">
        <p className="info-hero-lead">
          Bidsig helps you research investment ideas by simplifying data and surfacing general buy/sell signals you can explore on your own. Whether you&apos;re building a watchlist or managing a portfolio, the app brings structure to the process without the noise. Bidsig provides information and tools only — not personalized investment advice.
        </p>
      </div>
    </div>

    <section className="info-section" aria-labelledby="about-features-title">
      <h2 id="about-features-title" className="info-section-title">What Bidsig Offers</h2>
      <div className="info-feature-grid">
        {FEATURES.map(({ icon: Icon, title, description }) => (
          <article key={title} className="info-card info-feature-card">
            <div className="info-card-icon" aria-hidden>
              <Icon size={22} />
            </div>
            <h3 className="info-card-title">{title}</h3>
            <p className="info-card-text">{description}</p>
          </article>
        ))}
      </div>
    </section>

    <div className="info-closing-card">
      <p>
        Bidsig is built for investors who want to spend less time digging through raw data and more time making informed decisions. No fluff — just a focused utility for discovery, monitoring, and validation.
      </p>
    </div>
  </div>
);

export default About;
